export const MAX_ATTEMPTS = 24; //  24 attempts * 5 seconds = 120 seconds
export const POLL_INTERVAL = 5000;
